import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LoadingState } from "@/components/States";
import AppLayout from "@/components/AppLayout";

export default function ProtectedRoute({ children, perm, allowMfaPending = false }) {
  const { user, loading, can } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingState label="Authenticating" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  // Hard MFA gate: a user the policy says must enrol MFA can only see the setup
  // page until they finish enrolment.
  if (user.mfa_required && !allowMfaPending) return <Navigate to="/mfa/setup" replace />;

  // Client-portal users are confined to their own workspace, served at the clean /portal
  // path (no UUID in the URL). A client hitting /workspaces/<id> or anything else bounces here.
  if (user.user_type === "client") {
    const home = user.client_workspace_id ? "/portal" : null;
    const path = location.pathname;
    const allowed =
      !home ||
      path === home ||
      path.startsWith("/outputs/") ||
      path === "/settings";
    if (!allowed) return <Navigate to={home} replace />;
    return <AppLayout>{children}</AppLayout>;
  }

  if (perm && !can(perm)) {
    return (
      <AppLayout>
        <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
          <h2 className="font-heading text-2xl font-extrabold">Access Restricted</h2>
          <p className="mt-2 max-w-md text-sm text-muted-foreground">
            Your role does not have permission to view this module. Contact a Super Admin if you need access.
          </p>
        </div>
      </AppLayout>
    );
  }
  return <AppLayout>{children}</AppLayout>;
}
